export { useDeterrenceTest, type DeterrenceTest } from "./useDeterrenceTest";
